import withEntry from '../../../components/shared/withEntry';
import withModalEntry from '../../../components/shared/EntryWrapper';
import withLocalMessage from '../../../components/LocaleMessage';
import { EntryTypes } from '../../../utils/types/entry';

export const LocaleSelectionModalEntry = withEntry(
    withLocalMessage({ LanguageSelectionComponent: withModalEntry(EntryTypes.localeSelectionTrigger) })
);
